import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { joinCompanyApi } from '../../service/api/companies/joinCompany';
import InputField from '../../jsx/components/fields/inputField';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { setCurrentPage } from '../../feature/userData/userData';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import UserAddOwnCompany from '../companies/userAddOwnCompany';
import InternationalPhoneFormatFun from '../../ui/InternationalPhoneFormatFun';
import ResponceForAPI from '../../component/backDrop/responcesForAPI';
import { apiGetCompanyById } from '../../service/api/companies/getCompanyById';
import filter from '../../icons/photos/filter.svg';
import { MdContentCopy } from 'react-icons/md';
const CompanyManagement = () => {
    const { permissionArr, impersonateFlag, companyId, emailRedux, phoneNumberRedux, phoneCodeRedux, userName, userLastName, inProgressServiceCount } = useSelector((state) => state.user);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentPage("Company"));
    }, []);

    const permissionArray = permissionArr[0] || []
    const [joinCompanyCode, setJoinCompanyCode] = useState('');
    const [isJoinCompanyCodeError, setIsJoinCompanyCodeError] = useState(false);
    const [joinCompanyLoading, setJoinCompanyLoading] = useState(false);
    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState();
    const [handleToaster, setHandleToaster] = useState(false);
    const [companyModal, setCompanyModal] = useState(false)
    const [companyModalType, setCompanyModalType] = useState("")
    const [firstName, setFirstName] = useState(userName);
    const [lastName, setLastName] = useState(userLastName);
    const [apiResponse, setApiResponse] = useState(true);
    const [phoneNumberFormat, setPhoneNumberFormat] = useState();
    const [address, setAddress] = useState('')

    // International phone number formator
    useEffect(() => {
        if (phoneNumberRedux == null || phoneNumberRedux == "") {
            setPhoneNumberFormat(null);
        } else {
            setPhoneNumberFormat(
                InternationalPhoneFormatFun(`${countryCode}`, `${phonenumber}`)
            );
        }
    }, [phoneNumberRedux]);

    const handleClearCompanyStates = () => {
        setJoinCompanyCode('')
        setIsJoinCompanyCodeError(false)
    }

    const handleJoinCompany = (e) => {
        e.preventDefault()
        if (joinCompanyCode) {
            setJoinCompanyLoading(true)
            let formData = new FormData();
            formData.append("company_code_chr", joinCompanyCode);

            dispatch(
                joinCompanyApi(
                    formData,
                    (res) => {
                        setJoinCompanyLoading(false);
                        setResponceMsg(res.data.message);
                        setToasterType("success");
                        handleClearCompanyStates();

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //   setHandleToaster(false);
                        // }, 4000);
                    },
                    (err) => {
                        setJoinCompanyLoading(false);
                        setResponceMsg(err.data.message);
                        setToasterType("error");

                        setIsJoinCompanyCodeError(true);

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 4000);
                    }
                )
            );
        } else {
            setIsJoinCompanyCodeError(true)
        }
    }
    const handleJoinCompanyCode = (e) => {
        setIsJoinCompanyCodeError(false)
        setJoinCompanyCode(e.target.value)
    }

    const handleOpenRegisterComp = () => {
        setCompanyModal(true)
        setCompanyModalType("add");
    }

    const handleCloseCompanyModal = () => {
        setCompanyModal(false);
        // handleGetUserById();

        if (companyId) {
            handleGetCompanyDetails();
        }
    }

    const [EIN, setEIN] = useState("")
    const [companyName, setComapanyName] = useState("")
    const [countryCode, setCountryCode] = useState(phoneCodeRedux || 1);
    const [phonenumber, setPhonenumber] = useState(phoneNumberRedux);
    const [companyEmail, setComapanyEmail] = useState(emailRedux || "");
    const [placeIdVal, setPlaceId] = useState('')
    const [addressLine1, setAddressLine1] = useState(" ");
    const [addressLine2, setAddressLine2] = useState(" ");
    const [cityName, setCityName] = useState('')
    const [stateName, setStateName] = useState('')
    const [countryName, setCountryName] = useState(' ')
    const [zipCode, setZipCode] = useState(' ')
    const [latVal, setLatVal] = useState(0)
    const [longVal, setLongVal] = useState(0)
    const [companyAvatarUrl, setCompanyAvatarUrl] = useState("")
    const [expertiseArr, setExpertiseArr] = useState([]);
    const [companyCode, setCompanyCode] = useState('');


    const formatEINFromResponse = (einNumber) => {
        if (einNumber?.length === 9) {
            return `${einNumber?.slice(0, 2)}-${einNumber?.slice(2, 9)}`;
        }
        return einNumber;
    };

    const handleGetCompanyDetails = () => {
        let data = {
            company_id_ids: companyId
        }
        dispatch(apiGetCompanyById(data, (res) => {

            setFirstName(res?.data?.data?.first_name_chr)
            setLastName(res?.data?.data?.last_name_chr)
            res.data.data.ein_chr && setEIN(formatEINFromResponse(res.data.data.ein_chr))
            setComapanyName(res?.data?.data?.company_name_chr)
            setCountryCode(res?.data?.data?.company_phone_code_id_lng)
            setPhonenumber(res?.data?.data?.company_phone_number_int)
            setComapanyEmail(res?.data.data.company_email_chr)
            setPlaceId(res?.data?.data?.place_id_chr)
            setAddressLine1(res?.data?.data?.address_line_1_chr)
            setAddressLine2(res?.data?.data?.address_line_2_chr)
            setCityName(res?.data?.data?.city_name_chr)
            setStateName(res?.data?.data?.state_name_chr)
            setCountryName(res?.data?.data?.country_name_chr)
            setZipCode(res?.data?.data?.zip_code_int)
            setLongVal(res?.data?.data?.longitute_float)
            setLatVal(res?.data?.data?.latitude_float)
            setAddress(res?.data?.data?.company_address_chr)
            setCompanyAvatarUrl(res?.data?.data?.company_logo_url)
            setExpertiseArr(res?.data?.data?.company_expertise)
            setCompanyCode(res?.data?.data?.company_code_chr)

            setApiResponse(false)

        }, (err) => {
            setApiResponse(false)
        }))
    }

    useEffect(() => {
        if (companyId) {
            handleGetCompanyDetails();
        }
    }, [companyId])

    const copyToClipboard = () => {
        navigator.clipboard.writeText(`${companyCode}`);
        setResponceMsg("Company code copied to clipboard!");
        setToasterType("success");

        setHandleToaster(true);
        setTimeout(() => {
            setHandleToaster(false);
        }, 4000);
    }

    return (
        <>
            <div className="row mx-3 mb-5" style={{}}>
                <div className="col-12 px-0">

                    {!companyId ?
                        <div
                            className='d-flex justify-content-center align-items-center my-5'
                            style={{ height: '70vh' }}
                        >
                            <div className='w-100' style={{}}>
                                <div className="row mx-0">
                                    <div className='col-md-3'></div>
                                    <div className="col-md-6 px-3">

                                        <div className="row">
                                            <div className="col-12 px-0">
                                                <div
                                                    className="d-flex align-items-center justify-content-center text-black text-center font-w600 fs-3"
                                                >
                                                    {`Join company`}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mx-0">
                                            <div className="col-12 align-content-center d-flex fs-5 justify-content-center mt-3 px-0">
                                                <span className="text-center">{`Join an existing company`}</span>
                                            </div>
                                        </div>

                                        <div>
                                            <form onSubmit={(e) => handleJoinCompany(e)}>
                                                <div className="row mx-0 my-3 mt-4">
                                                    <div className="col-12 px-0">
                                                        <InputField
                                                            labelName={`Company code`}
                                                            placeholderName={"Company code"}
                                                            type={"text"}
                                                            value={joinCompanyCode}
                                                            onChange={handleJoinCompanyCode}
                                                            onBlur={() => { }}
                                                            errorMeesage={`Please enter valid company code`}
                                                            errorOccured={isJoinCompanyCodeError}
                                                            isRequired={true}
                                                        />
                                                    </div>
                                                </div>

                                                {inProgressServiceCount ? <div className="row mx-0">
                                                    <div className="col-12  d-flex mb-4 px-0">
                                                        <div>
                                                            <span className="text-center font-w600">{`Note : `}</span>
                                                            <span className="text-center">{`Please close your active service requests first, and then you will be able to join the company.`}</span>
                                                        </div>
                                                    </div>
                                                </div> : ''}

                                                <div className="row mx-0">
                                                    <div className="col-12 px-0">
                                                        <PrimaryButton
                                                            onClick={(e) => {
                                                                handleJoinCompany(e);
                                                            }}
                                                            buttonName={"JOIN"}
                                                            type="submit"
                                                            loadingMessage="SUBMITTING..."
                                                            isLoading={joinCompanyLoading}
                                                            style={{
                                                                width: '100%',
                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                opacity: inProgressServiceCount == 0 ? 1 : 0.5,
                                                                pointerEvents: inProgressServiceCount == 0 ? 'all' : 'none',
                                                                // border: 'none',
                                                                // background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                // boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </form>
                                        </div>


                                        {!companyId && permissionArray.includes("REGISTER COMPANY") &&
                                            <div>
                                                <div className="separator-custom mt-4 mb-2">
                                                    <div
                                                        className="line-custom me-3"></div>
                                                    <span className="text-custom fs-6">{`OR`}</span>
                                                    <div className="line-custom ms-3"></div>
                                                </div>

                                                <div className="row mx-0 mb-3">
                                                    <div className="col-12 align-content-center d-flex fs-5 justify-content-center px-0">
                                                        <span className="text-center">{`You want to register new company`}</span>
                                                    </div>
                                                </div>

                                                <div className="row mx-0">
                                                    <div className="col-12 px-0">
                                                        <PrimaryButton
                                                            onClick={(e) => {
                                                                handleOpenRegisterComp()
                                                            }}
                                                            buttonName={"REGISTER COMPANY"}
                                                            type="submit"
                                                            loadingMessage="SUBMITTING..."
                                                            isLoading={false}
                                                            style={{
                                                                width: '100%',
                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }


                                    </div>
                                    <div className='col-md-3'></div>
                                </div>
                            </div>
                        </div> :
                        <div
                            className='w-100 bg-light my-3'
                            style={{ position: 'relative' }}
                        >
                            <div className='row mx-0  w-100 h-100'>
                                <div className='col-12 d-flex flex-column justify-content-between p-4' style={{}}>
                                    <div>
                                        <div className='row border-3  mx-0 pb-2'>
                                            <div className='col-9 fs-4 fw-bold px-0 text-black'>
                                                <span>{"Company details"}</span>
                                            </div>
                                        </div>

                                        {companyAvatarUrl && (permissionArray.includes("VIEW OPEN SERVICE REQUESTS")) &&
                                            <div className='col-12 align-items-center d-flex justify-content-center px-0 my-3'>
                                                <div
                                                    className='d-flex align-items-center justify-content-center rounded-circle bg-light position-relative'
                                                    style={{ width: '70px', height: '70px' }}
                                                >
                                                    <img
                                                        src={companyAvatarUrl}
                                                        className='w-100 h-100 rounded-circle border'
                                                        alt="profile"
                                                        onClick={() => { }}
                                                    />
                                                </div>
                                            </div>
                                        }

                                        {companyAvatarUrl && (permissionArray.includes("VIEW COMPANY USERS")) &&
                                            <div className='col-12 align-items-center d-flex justify-content-center px-0 my-3'>
                                                <div
                                                    className='d-flex align-items-center justify-content-center rounded-circle bg-light position-relative'
                                                    style={{ width: '70px', height: '70px' }}
                                                >
                                                    <img
                                                        src={companyAvatarUrl}
                                                        className='w-100 h-100 rounded-circle border cursor-pointer'
                                                        alt="profile"
                                                        onClick={() => {
                                                            setCompanyModal(true)
                                                            if (permissionArray.includes("UPDATE COMPANY DETAIL")) {
                                                                setCompanyModalType("edit")
                                                            } else {
                                                                setCompanyModalType("view")
                                                            }
                                                        }}
                                                    />
                                                    <img
                                                        className='edit-profile-icon cursor-pointer'
                                                        src={filter}
                                                        alt=""
                                                        style={{ top: "-6px", right: '-14px' }}
                                                        onClick={() => {
                                                            setCompanyModal(true)
                                                            if (permissionArray.includes("UPDATE COMPANY DETAIL")) {
                                                                setCompanyModalType("edit")
                                                            } else {
                                                                setCompanyModalType("view")
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        }

                                        <div className='row border-3 border-bottom border-top border-white mx-0 py-1 fs-7'>
                                            <div className='col-6 fw-normal px-0'>
                                                <span>{"Company name"}</span>
                                            </div>
                                            <div className={`col-6 px-0 ${companyName ? 'text-black' : ''} font-w500`}>
                                                <span>{companyName ? companyName : "Not specified"}</span>
                                            </div>
                                        </div>

                                        <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                                            <div className='col-6 fw-normal px-0'>
                                                <span>{"First name"}</span>
                                            </div>
                                            <div className='col-6 px-0 text-black font-w500'>
                                                <span>{firstName}</span>
                                            </div>
                                        </div>

                                        <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                                            <div className='col-6 fw-normal px-0'>
                                                <span>{"Last name"}</span>
                                            </div>
                                            <div className={`col-6 px-0 ${lastName ? 'text-black' : ''} font-w500`}>
                                                <span>{lastName ? lastName : "Not specified"}</span>
                                            </div>
                                        </div>



                                        <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                                            <div className='mx-0 px-0 row'>
                                                <div className='col-6 fw-normal px-0'>
                                                    <span>{"Email"}</span>
                                                </div>
                                                <div className={`col-6 px-0 text-black font-w500 ${companyEmail ? 'text-black' : ''}`}>
                                                    <span>{companyEmail ? companyEmail : "Not specified"}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                                            <div className='mx-0 px-0 row'>
                                                <div className='col-6 fw-normal px-0'>
                                                    <span>{"Phone"}</span>
                                                </div>
                                                <div className={`col-6 px-0 font-w500 ${phoneNumberFormat ? 'text-black' : ''}`}>
                                                    <span>{phoneNumberFormat != null ? phoneNumberFormat : "Not specified"}</span>
                                                </div>
                                            </div>
                                        </div>

                                        {(permissionArray.includes("VIEW COMPANY USERS")) && <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                                            <div className='col-6 fw-normal px-0'>
                                                <span>{"EIN"}</span>
                                            </div>
                                            <div className={`col-6 px-0 text-black font-w500 ${EIN ? 'text-black' : ''}`}>
                                                <span>{EIN ? EIN : "Not specified"}</span>
                                            </div>
                                        </div>}


                                        <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                                            <div className='col-6 fw-normal px-0'>
                                                <span>{"Address"}</span>
                                            </div>
                                            <div className={`col-6 px-0  font-w500 ${address ? 'text-black' : ''}`}>
                                                <span>{address ? address : "Not specified"}</span>
                                            </div>
                                        </div>

                                        <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                                            <div className='col-6 fw-normal px-0'>
                                                <span>{"Expertise"}</span>
                                            </div>
                                            <div className={`col-6 px-0  font-w500 ${expertiseArr?.length > 0 ? 'text-black' : ''}`}>
                                                {expertiseArr?.length > 0 ?
                                                    <>
                                                        {expertiseArr?.map((item, ind) => {
                                                            return (
                                                                <span key={ind}>{`${item?.expertise_name_chr}, `}</span>
                                                            )
                                                        })}
                                                    </> :
                                                    <span>{"Not specified"}</span>
                                                }
                                            </div>
                                        </div>

                                        {(permissionArray.includes("VIEW COMPANY USERS")) && <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                                            <div className='col-6 fw-normal px-0'>
                                                <span>{"Company code"}</span>
                                            </div>
                                            <div className={`col-6 px-0  font-w500 ${address ? 'text-black' : ''}`}>
                                                <span className='me-3'>{companyCode ? companyCode : "Not specified"}</span>
                                                <div className="tooltipCustom ">
                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Copy to clipboard"}</span>
                                                    <span
                                                        onClick={() => { copyToClipboard() }}
                                                        className={`cursor-pointer text-hovered`}
                                                    >
                                                        <MdContentCopy />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>}

                                    </div>

                                    <div className="mt-5">
                                        {companyId && permissionArray.includes("VIEW COMPANY USERS") &&
                                            <div className='row mx-0 '>
                                                <div className='col-12 fs-6 px-0'>
                                                    <div className='d-flex'>
                                                        <div onClick={() => {
                                                            setCompanyModal(true)
                                                            if (permissionArray.includes("UPDATE COMPANY DETAIL")) {
                                                                setCompanyModalType("edit")
                                                            } else {
                                                                setCompanyModalType("view")
                                                            }
                                                        }}
                                                            className='align-items-center text-black font-w600 rounded-1 cursor-pointer d-flex overlay-action-btn px-2 text-hovered'>
                                                            <span>
                                                                {`${permissionArray.includes("UPDATE COMPANY DETAIL") ? "Edit company details" : "View company details"}`}

                                                            </span>
                                                            <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            {apiResponse && <ResponceForAPI show={apiResponse} />}
                        </div>
                    }
                </div>
            </div>

            {companyModal &&
                <UserAddOwnCompany
                    companyModalStatus={companyModal}
                    setCompanyModalStatus={setCompanyModal}
                    handleClose={() => { handleCloseCompanyModal() }}
                    modalType={companyModalType}
                    companyID={companyId}
                    firstNameOwner={firstName}
                    lastNameOwner={lastName}
                    emailOwner={emailRedux}
                    phoneNumberOwner={phoneNumberRedux}
                    countryCodeOwner={phoneCodeRedux}
                />
            }

            {
                handleToaster && (
                    <ResponceToaster toasterType={toasterType} message={responceMsg} />
                )
            }
        </>
    )
}

export default CompanyManagement